__turbopack_context__.v({
  "active": "TemplatesTabs-module__sjdsFG__active",
  "tabContainer": "TemplatesTabs-module__sjdsFG__tabContainer",
});
